import { ColumnViewModel } from '../../shared/column-types';

export const CHEMICALS_GDA_SUMMARY: ColumnViewModel = {
  columns: [
    'chemPrefName',
    'chemID',
    'geneSymbol',
    'geneDescription',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiID',
    'numDiseasesAssociatedToGene',
    'numDBSNPsupportingAssociation',
    'numGenesAssociatedToDisease',
    'numVariantsAssociatedToDisease',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numVariantsAssociatedToGene',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'disease_prevalence_class',
    'disease_prevalence_type',
    'disease_prevalence_geo_area',
    'disease_inheritance',
    'geneEnsemblIDs',
    'geneNcbiType',
    'geneProteinStrIDs',
    'geneProteinClassNames',
    'pathwayName',
    'pathwayID',
    'numCTs',
  ],
  defaultVisible: [
    'chemPrefName',
    'chemID',
    'geneSymbol',
    'geneDescription',
    'diseaseName',
    'numDiseasesAssociatedToGene',
    'numGenesAssociatedToDisease',
    'score',
    'sourceScore',
    'numPMIDsupportingAssociation',
    'numberChemsIncludedInEvidence',
    'numVariantsAssociatedToGene',
    'yearInitial',
    'yearFinal',
    'EI',
    'EL',
    'geneDSI',
    'geneDPI',
    'genepLI',
    'diseaseType',
    'diseaseClassName_MSH',
    'numCTs',
  ],
};